import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import axios from 'axios';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import ImprovedSelect from '../Form/Fields/ImprovedSelect';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

export default function CreateUserModal({ show, onClose, onSaved, employee = null }) {
    const isEdit = employee != null;
    const [isLoading, setIsLoading] = useState(false);
    const [roleOptions, setRoleOptions] = useState([]);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/v1/admin/roles`, {
            params: { page: 0, size: 100 },
            withCredentials: true,
        }).then(({ data }) => {
            setRoleOptions((data.content || []).map(r => ({ value: r.id, label: r.name })));
        }).catch(() => {});
    }, []);

    const defaultValues = isEdit ? {
        firstName: employee.firstName ?? '',
        lastName:  employee.lastName  ?? '',
        email:     employee.email     ?? '',
        password:  '',
        roleIds:   employee.roleIds   ?? [],
    } : {
        firstName: '',
        lastName:  '',
        email:     '',
        password:  '',
        roleIds:   [],
    };

    const onSubmit = (data) => {
        const roleIds = Array.isArray(data.roleIds)
            ? data.roleIds.map(r => (typeof r === 'object' ? r.value : r))
            : [];

        const payload = { ...data, roleIds };

        const request = isEdit
            ? axios.put(`${API_BASE_URL}/api/v1/admin/users/${employee.id}`, payload, { withCredentials: true })
            : axios.post(`${API_BASE_URL}/api/v1/admin/users`, payload, { withCredentials: true });

        setIsLoading(true);
        request
            .then(() => {
                toast.success(isEdit ? 'Utilisateur mis à jour.' : 'Utilisateur créé.');
                onSaved();
                onClose();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Une erreur est survenue.'))
            .finally(() => setIsLoading(false));
    };

    return (
        <Modal
            id="createUserModal"
            title={isEdit ? "Modifier l'utilisateur" : 'Nouvel utilisateur'}
            show={show}
            onClose={onClose}
            icon={faUser}
            iconBg="#e0e7ff"
            iconColor="#4338ca"
            footer={
                <Button isLoading={isLoading} loadingMessage="Enregistrement ..." type="submit" form="userForm" className="modal-btn-primary">
                    {isEdit ? 'Enregistrer' : 'Créer'}
                </Button>
            }
        >
            <Form id="userForm" onSubmit={onSubmit} defaultValues={defaultValues} key={employee?.id ?? 'new'}>
                <div className="cdm-section">
                    <p className="cdm-section__label">Informations</p>

                    <div className="cdm-grid-2 mb-2">
                        <div>
                            <label className="cdm-field-label">Prénom <span className="text-danger">*</span></label>
                            <InputText name="firstName" placeholder="Prénom" validationRules={{ required: 'Requis' }} />
                        </div>
                        <div>
                            <label className="cdm-field-label">Nom <span className="text-danger">*</span></label>
                            <InputText name="lastName" placeholder="Nom" validationRules={{ required: 'Requis' }} />
                        </div>
                    </div>

                    <div>
                        <label className="cdm-field-label">Email <span className="text-danger">*</span></label>
                        <InputText name="email" placeholder="email@pharmacie.ma" validationRules={{ required: 'Requis' }} />
                    </div>
                </div>

                <div className="cdm-section">
                    <p className="cdm-section__label">Accès</p>

                    <div className="mb-2">
                        <label className="cdm-field-label">
                            Mot de passe {!isEdit && <span className="text-danger">*</span>}
                            {isEdit && <span className="text-muted" style={{ fontSize: 11 }}> (laisser vide pour ne pas changer)</span>}
                        </label>
                        <InputText
                            name="password"
                            type="password"
                            placeholder="••••••••"
                            validationRules={!isEdit ? { required: 'Requis' } : {}}
                        />
                    </div>

                    <div>
                        <label className="cdm-field-label">Rôles</label>
                        <ImprovedSelect
                            name="roleIds"
                            options={roleOptions}
                            multiple={true}
                            placeholder="Sélectionner des rôles..."
                        />
                    </div>
                </div>
            </Form>
        </Modal>
    );
}
